import React, { Component } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import Select from "react-select";

export default class CreateSessionObjectModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alias: "",
      objectType: "message",
      validated: false
    };
    this.formRef = React.createRef();
  }

  handleCreate(event) {
    event.preventDefault();
    event.stopPropagation();

    const form = this.formRef.current;
    const { alias, objectType } = this.state;
    const { existingAliases } = this.props;

    // Check HTML5 validation first
    if (!form.checkValidity()) {
      this.setState({ validated: true });
      return;
    }

    // Custom validation for uniqueness
    if (existingAliases && existingAliases.includes(alias)) {
      form.elements.alias.setCustomValidity("Alias must be unique within the scope of the session.");
      this.setState({ validated: true });
      return;
    }

    this.props.onSave(alias, objectType);
    this.props.onHide();
    this.resetState();
  }

  resetState() {
    this.setState({
      alias: "",
      objectType: "message",
      validated: false
    });
  }

  handleClose() {
    this.props.onHide();
    this.resetState();
  }

  handleAliasChange(value) {
    // Clear custom validity when user types
    if (this.formRef.current) {
      this.formRef.current.elements.alias.setCustomValidity("");
    }
    this.setState({ alias: value });
  }

  render() {
    return (
      <Modal
        show={this.props.show}
        onHide={() => this.handleClose()}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Create Session Object</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ marginBottom: "20px" }}>
            Session Object is a key-value pair stored within the session context. 
            It can be used to store configuration, specialized data, or shared state accessible by workflow steps.
          </div>
          
          <hr />

          <Form 
            noValidate 
            validated={this.state.validated} 
            onSubmit={(e) => this.handleCreate(e)}
            ref={this.formRef}
          >
            <Form.Group>
              <Form.Label><strong>Alias</strong></Form.Label>
              <Form.Control
                type="text"
                name="alias"
                placeholder="Enter object alias"
                value={this.state.alias}
                onChange={(e) => this.handleAliasChange(e.target.value)}
                required
                minLength={1}
                maxLength={32}
                pattern="^[a-zA-Z0-9\-_]+$"
              />
              <Form.Control.Feedback type="invalid">
                Please enter a valid alias (1-32 characters, alphanumeric with - and _ allowed).
              </Form.Control.Feedback>
              <Form.Text className="text-muted">
                Session object alias must confirm to the following requirements:
                <ul>
                  <li>minimum of 1 characters;</li>
                  <li>maximum of 32 characters;</li>
                  <li>only alphanumeric characters along with -,_ are allowed;</li>
                  <li>must be unique within the scope of the session.</li>
                </ul>
              </Form.Text>
            </Form.Group>
            <Form.Group style={{ marginTop: "15px" }}>
              <Form.Label><strong>Object Type</strong></Form.Label>
              <div style={{ maxWidth: "200px" }}>
                <Select
                  options={[
                    { value: "message", label: "message" },
                    { value: "thread", label: "thread" }
                  ]}
                  value={{ value: this.state.objectType, label: this.state.objectType }}
                  onChange={(option) => this.setState({ objectType: option.value })}
                />
              </div>
              <Form.Text className="text-muted">
                Select the type of object to create.
              </Form.Text>
            </Form.Group>
            <button type="submit" style={{ display: "none" }} />
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => this.handleClose()}>
            Cancel
          </Button>
          <Button variant="success" onClick={(e) => this.handleCreate(e)}>
            Create & Edit
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
